export default "__VITE_ASSET__C816StAU__"